export function getFormattedUserCount(usersCount: number) {
  if (!usersCount) return null;
  return usersCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
